import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { Card } from '@/components/ui/card';
import { OUTCOME_COLORS } from './reportShared';
import { outcomeLabel } from '../outcomeApi';

export function SummaryTiles({ totals, byAdmin }) {
  const tiles = [
    { label: 'Interactions logged', value: totals.interactions, testId: 'report-total-interactions' },
    { label: 'Partners re-engaged', value: totals.unique_partners, testId: 'report-total-partners' },
    { label: 'Will refer', value: totals.by_outcome?.will_refer || 0, testId: 'report-total-will-refer' },
    { label: 'Team members active', value: byAdmin.length, testId: 'report-total-team' },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="report-summary">
      {tiles.map(t => (
        <div key={t.label} className="p-4 rounded-lg border bg-white" data-testid={t.testId}>
          <div className="text-xs text-muted-foreground">{t.label}</div>
          <div className="text-3xl font-bold mt-1">{t.value}</div>
        </div>
      ))}
    </div>
  );
}

export function DailyChart({ daily, outcomeKeys }) {
  const data = daily.map(d => ({
    date: new Date(d.date + 'T00:00:00').toLocaleDateString(undefined, { day: 'numeric', month: 'short' }),
    ...Object.fromEntries(outcomeKeys.map(k => [k, d.by_outcome[k] || 0])),
  }));
  return (
    <Card className="p-4" data-testid="report-daily-chart">
      <div className="text-sm font-semibold mb-3">Interactions per day by outcome</div>
      <div style={{ height: 280 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="date" fontSize={11} />
            <YAxis allowDecimals={false} fontSize={11} />
            <Tooltip formatter={(v, k) => [v, outcomeLabel(k)]} />
            <Legend formatter={(k) => outcomeLabel(k)} wrapperStyle={{ fontSize: 11 }} />
            {outcomeKeys.map(k => <Bar key={k} dataKey={k} stackId="a" fill={OUTCOME_COLORS[k] || '#888'} />)}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}

export function BreakdownTable({ title, rows, outcomeKeys, labelKey, testId }) {
  return (
    <Card className="overflow-x-auto" data-testid={testId}>
      <div className="text-sm font-semibold p-4 pb-2">{title}</div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-xs text-muted-foreground border-b">
            <th className="text-left p-2 pl-4">{labelKey === 'name' ? 'Team member' : 'Date'}</th>
            <th className="text-right p-2">Interactions</th>
            <th className="text-right p-2">Partners</th>
            {outcomeKeys.map(k => <th key={k} className="text-right p-2 whitespace-nowrap">{outcomeLabel(k)}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.email || r.date} className="border-b last:border-0 hover:bg-muted/30" data-testid={`${testId}-row-${r.email || r.date}`}>
              <td className="p-2 pl-4 font-medium whitespace-nowrap">
                {labelKey === 'name' ? <>{r.name}<div className="text-xs text-muted-foreground font-normal">{r.email}</div></>
                  : new Date(r.date + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' })}
              </td>
              <td className="p-2 text-right font-semibold">{r.interactions}</td>
              <td className="p-2 text-right">{r.unique_partners}</td>
              {outcomeKeys.map(k => <td key={k} className="p-2 text-right text-muted-foreground">{r.by_outcome[k] || '·'}</td>)}
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={3 + outcomeKeys.length} className="p-6 text-center text-muted-foreground">Nothing logged in this period.</td></tr>}
        </tbody>
      </table>
    </Card>
  );
}
